export const TYPOGRAPHY = {
  fontFamily: 'Lato, sans-serif',
} as const;
